module.exports = __webpack_public_path__ + "static/media/ki.706af255.png";